// extracted by mini-css-extract-plugin
export default {"button":"ShowMoreText_button__DAVkQ","text":"ShowMoreText_text__zsn30","textHide":"ShowMoreText_textHide__XsP1m"};